import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useState, useRef, useEffect } from "react"; // Add useRef
import { useTransfer2Card } from "@/hooks/use-mutations";
import { useUser } from "@/zustand/store";
import { formatAmount } from "@/lib/utils";
import { useQueryClient } from "@tanstack/react-query";
import { useModalStore } from "@/zustand/modalStore";

const FundCard = ({
  cardData,
  closeModal,
}: {
  closeModal: () => void;
  cardData: Card;
}) => {
  const queryClient = useQueryClient();
  const { user } = useUser();
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const { openModal } = useModalStore();
  const { mutateAsync: transfer2Card, isPending: isTransferPending } =
    useTransfer2Card({
      id: cardData.id,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["user", "deposits", "cardInfo", cardData.id],
        });
        openModal("success", { type: "card-topup" });
      },
    });

  const onSubmit = () => {
    transfer2Card({
      side: "fund",
      amount: amount,
    });
  };

  return (
    <div className="relative z-[999]">
      <h4 className="mt-6 text-sm font-medium">Wallet balance</h4>
      <p className="text-2xl font-medium">${formatAmount(user?.balance)}</p>
      <h4 className="mt-2 text-sm font-medium">Amount</h4>
      <Input
        type="text"
        inputMode="numeric"
        value={amount}
        onChange={(e) => {
          const value = e.target.value.replace(/[^0-9.]/g, "");
          setAmount(value);
          if (Number(value) > user?.balance) {
            setError("Amount exceeds your wallet balance");
          } else {
            setError("");
          }
        }}
        placeholder="Enter amount"
        className="bg-primary-500/60 border-border-neutral/30 relative mt-2 h-11 text-white placeholder:text-white lg:text-xs lg:placeholder:text-xs"
      />
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
      <div className="mt-4">
        <h4 className="text-sm font-semibold">Fund your Card</h4>
        <div className="mt-1 flex items-center gap-3 text-xs">
          <span>
            {cardData.firstName} {cardData.lastName}
          </span>
          <span className="">**** {cardData.last4}</span>
        </div>
      </div>
      <Button
        isLoading={isTransferPending}
        onClick={onSubmit}
        disabled={
          Number(amount) <= 0 ||
          Number(amount) > user?.balance ||
          isTransferPending
        }
        className="text-primary-500 bg-primary-100 hover:bg-primary-100-hover mt-4 h-11 w-full rounded-md"
      >
        Continue
      </Button>
    </div>
  );
};

export default FundCard;
